import { useState } from 'react';
import copy from 'copy-to-clipboard';
import {
  ButtonPseudo,
  ButtonSecondary,
  ButtonSize,
  IconCopy,
  IconDown,
  IconDownload,
  IconUp,
} from '@ui/src';
import { TopUpInstructionTypes } from './types';
import { PspPartnerPaymentType } from '../../../hoc/common/types';

import cn from './styles.module.css';

const TopUpInstruction = ({
  instruction,
  index,
  getTopUpInstructionPdf,
  pdfDownloadInProgress,
  selectedInstructionType,
  paymentTypes,
}: TopUpInstructionTypes) => {
  const [collapsed, setCollapsed] = useState(true);
  const [copyIsSuccess, setCopyIsSuccess] = useState(false);

  const onCopy = () => {
    if (
      instruction?.paymentType !== PspPartnerPaymentType.CRYPTO_ASSET_PAYMENT
    ) {
      copy(
        `Beneficiary: ${instruction?.beneficiary} 
Beneficiary address: ${instruction?.beneficiaryAddress || '-'} 
Beneficiary account: ${instruction?.beneficiaryAccountNumber?.join(', ')} 
Beneficiary Bank: ${instruction?.beneficiaryBankName}
${
  instruction?.paymentType === PspPartnerPaymentType.FEDWIRE
    ? `ABA: ${instruction?.beneficiaryBankABA}`
    : ''
}${
          instruction?.paymentType !== PspPartnerPaymentType.FEDWIRE
            ? `${
                instruction?.paymentType ===
                  PspPartnerPaymentType.FASTER_PAYMENT ||
                instruction?.paymentType === PspPartnerPaymentType.BACS
                  ? 'Beneficiary Bank Sort Code:'
                  : 'Beneficiary Bank BIC:'
              } ${instruction?.beneficiaryBankBIC} `
            : ''
        }
Purpose of the payment: ${instruction?.purposeOfPayment}`,
      );
    } else if (
      instruction?.paymentType === PspPartnerPaymentType.CRYPTO_ASSET_PAYMENT
    ) {
      copy(
        `Beneficiary wallet address: ${instruction?.beneficiaryAccountNumber?.join(', ')} 
Network: ${instruction?.casp?.name}
Purpose of the payment: ${instruction?.purposeOfPayment}`,
      );
    }

    setCopyIsSuccess(true);

    setTimeout(() => {
      setCopyIsSuccess(false);
    }, 2000);
  };

  return (
    <div className={cn.topupInstruction}>
      <button
        type="button"
        className={`${cn.topupInstructionTitle} ${
          collapsed ? cn.withBorder : ''
        }`}
        onClick={() => setCollapsed(!collapsed)}
      >
        {instruction?.paymentType !== 'CRYPTO_ASSET_PAYMENT'
          ? paymentTypes?.find(
              (item) => item.paymentType === instruction?.paymentType,
            )?.name
          : `${instruction?.casp?.name} Payment`}
        {collapsed ? (
          <IconDown width={14} height={14} />
        ) : (
          <IconUp width={14} height={14} />
        )}
      </button>
      {!collapsed && (
        <div className={cn.instructionWrapper}>
          {instruction?.paymentType !== 'CRYPTO_ASSET_PAYMENT' && (
            <>
              <div className={cn.instructionRow}>
                <div className={cn.instructionRowTitle}>Beneficiary:</div>
                <div className={cn.instructionRowValue}>
                  {instruction?.beneficiary}
                </div>
              </div>
              <div className={cn.instructionRow}>
                <div className={cn.instructionRowTitle}>
                  Beneficiary address:
                </div>
                <div className={cn.instructionRowValue}>
                  {instruction?.beneficiaryAddress || '-'}
                </div>
              </div>
            </>
          )}
          <div className={cn.instructionRow}>
            <div className={cn.instructionRowTitle}>
              {instruction?.paymentType !== 'CRYPTO_ASSET_PAYMENT'
                ? 'Beneficiary account:'
                : 'Beneficiary wallet address:'}
            </div>
            <div className={cn.instructionRowValue}>
              {instruction?.beneficiaryAccountNumber?.join(', ')}
            </div>
          </div>
          {instruction?.paymentType === 'CRYPTO_ASSET_PAYMENT' && (
            <div className={cn.instructionRow}>
              <div className={cn.instructionRowTitle}>Network:</div>
              <div className={cn.instructionRowValue}>
                {instruction?.casp?.name}
              </div>
            </div>
          )}
          {instruction?.paymentType !== 'CRYPTO_ASSET_PAYMENT' && (
            <>
              <div className={cn.instructionRow}>
                <div className={cn.instructionRowTitle}>Beneficiary Bank:</div>
                <div className={cn.instructionRowValue}>
                  {instruction?.beneficiaryBankName}
                </div>
              </div>
              {instruction?.paymentType !== 'FEDWIRE' && (
                <div className={cn.instructionRow}>
                  <div className={cn.instructionRowTitle}>
                    {instruction?.paymentType ===
                      PspPartnerPaymentType.FASTER_PAYMENT ||
                    instruction?.paymentType === PspPartnerPaymentType.BACS
                      ? 'Beneficiary Bank Sort Code:'
                      : 'Beneficiary Bank BIC:'}
                  </div>
                  <div className={cn.instructionRowValue}>
                    {instruction?.beneficiaryBankBIC}
                  </div>
                </div>
              )}
              {instruction?.paymentType === 'FEDWIRE' &&
                instruction.beneficiaryBankABA && (
                  <div className={cn.instructionRow}>
                    <div className={cn.instructionRowTitle}>ABA:</div>
                    <div className={cn.instructionRowValue}>
                      {instruction?.beneficiaryBankABA}
                    </div>
                  </div>
                )}
              {instruction?.intermediaryBankName && (
                <div className={cn.instructionRow}>
                  <div className={cn.instructionRowTitle}>
                    Intermediary bank:
                  </div>
                  <div className={cn.instructionRowValue}>
                    {instruction?.intermediaryBankName}
                  </div>
                </div>
              )}
              {instruction?.intermediaryBankSwift && (
                <div className={cn.instructionRow}>
                  <div className={cn.instructionRowTitle}>
                    Intermediary bank Swift:
                  </div>
                  <div className={cn.instructionRowValue}>
                    {instruction?.intermediaryBankSwift}
                  </div>
                </div>
              )}
              {instruction?.accountOfCorrespondentWithIntermediaryBank && (
                <div className={cn.instructionRow}>
                  <div className={cn.instructionRowTitle}>
                    Account of Correspondent with Intermediary Bank:
                  </div>
                  <div className={cn.instructionRowValue}>
                    {instruction?.accountOfCorrespondentWithIntermediaryBank}
                  </div>
                </div>
              )}
            </>
          )}
          <div className={cn.instructionRow}>
            <div className={cn.instructionRowTitle}>
              Purpose of the payment:
            </div>
            <div className={cn.instructionRowValue}>
              {instruction?.purposeOfPayment}
            </div>
          </div>
          <div className={cn.instructionControls}>
            <ButtonSecondary
              text={
                pdfDownloadInProgress &&
                selectedInstructionType === instruction?.paymentType
                  ? 'Loading...'
                  : 'Download'
              }
              icon={
                pdfDownloadInProgress &&
                selectedInstructionType ===
                  instruction?.paymentType ? undefined : (
                  <IconDownload />
                )
              }
              size={ButtonSize.SMALL}
              className={cn.downloadInstructionButton}
              onClick={() =>
                getTopUpInstructionPdf(
                  index,
                  instruction?.paymentType as PspPartnerPaymentType,
                )
              }
            />
            <div className={cn.copyButtonWrapper}>
              {copyIsSuccess && (
                <div className={cn.instructionDetailsCopied}>
                  Details copied
                </div>
              )}
              <ButtonPseudo
                text="Copy"
                icon={<IconCopy />}
                size={ButtonSize.SMALL}
                onClick={() => onCopy()}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopUpInstruction;
